import { createFileRoute, redirect } from '@tanstack/react-router';

import { isSettingsSection } from '@/features/settings/settings-sections';

export const Route = createFileRoute('/_authenticated/settings/$section')({
  validateSearch: (search: Record<string, unknown>): { item?: string } =>
    typeof search.item === 'string' ? { item: search.item } : {},
  beforeLoad({ params }) {
    if (isSettingsSection(params.section)) return;
    throw redirect({
      to: '/settings/$section',
      params: { section: 'General' },
      replace: true,
    });
  },
  // a pendingComponent gives this match its own Suspense boundary, so a
  // pending leaf never bubbles up to the _authenticated layout's splash
  pendingComponent: () => null,
});
